(() => {
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency }).format(Number(cents || 0) / 100);
  document.querySelectorAll('[data-bek-store-product]').forEach((root) => {
    const select = root.querySelector('[data-bek-variant-select]');
    const price = root.querySelector('[data-bek-product-price]');
    const button = root.querySelector('[data-bek-add-to-cart]');
    const dataEl = root.querySelector('[data-bek-variants-json]');
    if (!select || !dataEl) return;
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent || '[]'); } catch (_) { return; }
    const currency = root.dataset.currency || 'EUR';
    const sync = () => {
      const variant = variants.find((v) => String(v.id) === String(select.value));
      if (!variant) return;
      if (price) price.textContent = money(variant.price, currency);
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'In den Warenkorb →' : 'Aktuell nicht verfügbar';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.pathname + url.search + url.hash);
    };
    select.addEventListener('change', sync);
    sync();
  });
})();
